const CLUB_SQUARE_BANNER_IMAGE = "/img/julebu1.jpg";
const CLUB_SQUARE_LOCKED_IMAGE = "/img/julebu2.jpg";

module.exports = {
  CLUB_SQUARE_BANNER_IMAGE,
  CLUB_SQUARE_LOCKED_IMAGE,
};
